import React, { useEffect, useState } from 'react';
import { makeStyles, CardContent, Grid, FormControl, InputLabel, Select, Card, Typography } from '@material-ui/core';
import axios from 'axios';
import { useSelector } from 'react-redux';
import PaymentTable from '../PaymentTable/PaymentTable';
import { CommonConfig } from '../../../config/common-config';
import SearchBox from '../../../components/table/SearchBox';
import LoaderPopUp from '../../../components/loaderpopup/loader';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

function IndividualPaymentHistory(props, row) {
    const [selectedImc, setselectedImc] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [AllImcs, setAllImcs] = useState([]);
    const [rows, setTotalReactPackages] = useState([]);
    const [handleGeneratedReceipt, setHandleGeneratedReceipt] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [allCorps, setAllCorps] = useState([]);
    const [selectedCorp, setselectedCorp] = useState([]);
    // const username = JSON.parse(sessionStorage.getItem('user'));
    // const { userName } = username.result.data;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantname = tennantDetails && tennantDetails.tennantName;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const firstNameCorp = userDetails.result && userDetails.result.data.firstName;
    const lastNameCorp = userDetails.result && userDetails.result.data.lastName;
    const usertype = userDetails.result && userDetails.result.data.userType;
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userDomain = userDetails.result && userDetails.result.config.data;
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [searchData, setSearchData] = useState([]);
    // const [noRecordCount, setNoRecordCount] = useState(false);

    let headcells = [];

    userTeam === 'Team'
        ? (headcells = [
            { id: 'clientId', label: 'Client ID' },
            { id: 'clientName', label: 'Client Name' },
            {
                id: 'invoiceId',
                label: 'Service ID',
                isConcat: 'true',
                concatElem: ['serviceId'],
            },
            {
                id: 'invoiceId',
                label: 'Invoice Number',
                isConcat: 'true',
                concatElem: ['invoiceNumber'],
            },
            {
                id: 'invoiceId',
                label: 'Invoice Date',
                isConcat: '',
                concatElem: ['invoiceDate'],
            },
            {
                id: 'invoiceId',
                label: 'Invoice amount',
                isConcat: 'true',
                concatElem: ['total'],
            },
            {
                id: 'paymentDate',
                label: 'Amount Remitted On',
                date: 'true',
            },
            {
                id: 'razorpayPaymentId',
                label: 'Reference Number',
            },
        ])
        : (headcells = [
            {
                id: 'invoiceId',
                label: 'Service ID',
                isConcat: 'true',
                concatElem: ['serviceId'],
            },
            {
                id: 'invoiceId',
                label: 'Invoice Number',
                isConcat: 'true',
                concatElem: ['invoiceNumber'],
            },
            {
                id: 'invoiceId',
                label: 'Invoice Date',
                isConcat: '',
                concatElem: ['invoiceDate'],
            },
            {
                id: 'invoiceId',
                label: 'Invoice amount',
                isConcat: 'true',
                concatElem: ['total'],
            },
            {
                id: 'paymentDate',
                label: 'Amount Remitted On',
                date: 'true',
            },
            {
                id: 'razorpayPaymentId',
                label: 'Reference Number',
            },
        ]);

    // const getCandidates = () => {
    //     // dispatch(getPaymentsDetails());
    // };


    function formatDate(props) {
        return props.map((element) => {
            // const tempEndDate = element.dateModified;
            const tempPaymentDate = element.paymentDate;
            // element.dateModified = tempEndDate.split(' ', 1);
            element.paymentDate = tempPaymentDate.split(' ', 1);
        });
    }

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => setAllImcs(response.data.content))
            .catch(() => {
            });

        if (userTeam != 'ITeC Team') {
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain);
                setselectedImc(JsonUserDomain.tennantName);
                setImc(JsonUserDomain.tennantName);
            }
        }

        if (usertype === 'CORETEAM') {
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history/${tennantname}?page=${page}&size=10&sort=paymentId,desc`, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    formatDate(response.data.content);
                    setTotalReactPackages(response.data.content);
                    setPageDetails(response.data);
                    setLoading(false);
                    if (response.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (response.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                })
                .catch(() => {
                });
        }
    }, [handleGeneratedReceipt, userToken, page]);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }
        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    const handleGenerateReceipt = (data) => {
        setShowBtnLoader(true);
        if (data.paymentId) {
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/generate-receipt/${selectedImc}/${data.paymentId}`, '', {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    setHandleGeneratedReceipt(response.data.content);
                    setShowBtnLoader(false);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                    }
                });
        }
    };

    // search Query
    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);
        if (searchData && searchData.length > 2) {
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain);
                getSearchValue(JsonUserDomain.tennantName, searchData);
            }
            return true;
        } else {
        }
        if (!searchData) {
            setSearchData([]);
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain);
                setImc(JsonUserDomain.tennantName);
            }
        }
    };

    const getSearchValue = (e, data) => {
        let imc = '';
        if (e.target) {
            imc = e.target.value;
        } else {
            imc = e;
        }
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/payment-history-clients/${imc}/Individual/${firstNameCorp} ${lastNameCorp}?search=${data}&page=0&size=1000&sort=paymentId,desc`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((res) => {
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setTotalReactPackages([]);
                    }
                    formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => { });
    };

    const allCorpOptions = (corpData) => {
        const OptionList = corpData.map((corp) => <option value={corp.corpclientId}>{corp.corpClientName}</option>);
        return OptionList;
    };

    const setCorp = (e) => {
        setselectedCorp(e.target.value);
        axios
            .get(`${CommonConfig.dev.baseUrl}/auth/intClient-colleague/${selectedImc}/${e.target.value}?page=0&size=1000`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setTotalReactPackages(response.data.content);
            })
            .catch(() => {

            });
    };

    const setImc = (e) => {
        let imc = '';
        if (e.target) {
            imc = e.target.value;
        } else {
            imc = e;
        }
        setselectedImc(imc);
        if (usertype === 'INDIVIDUAL') {
            axios
                .get(
                    `${CommonConfig.dev.baseUrl}/api/auth/payment-history-clients/${imc}/Individual/${firstNameCorp} ${lastNameCorp}?page=${page}&size=10&sort=paymentId,desc`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    formatDate(response.data.content);
                    setTotalReactPackages(response.data.content);
                    setPageDetails(response.data);
                    setLoading(false);
                    if (response.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (response.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                })
                .catch(() => { });
        }

        if (usertype === 'CORPORATE') {
            axios
                .get(
                    `${CommonConfig.dev.baseUrl}/api/auth/payment-history-clients/${imc}/Corporate/${firstNameCorp}?page=${page}&size=10&sort=paymentId,desc`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    formatDate(response.data.content);
                    setTotalReactPackages(response.data.content);
                    setPageDetails(response.data);
                    setLoading(false);
                    if (response.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (response.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                })
                .catch(() => {
                });
        }
    };

    const setImcCorporate = (e) => {
        setselectedImc(e.target.value);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${e.target.value}?page=0&size=1000`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setAllCorps(response.data.content);
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                }
            });
    };

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        if (userDomain) {
            let JsonUserDomain = JSON.parse(userDomain);
            setImc(JsonUserDomain.tennantName);
        }
    };

    const filteredRow = searchData && searchData.length ? searchData : rows;
    const classes = useStyles();

    return (
        <>
            {(showBtnLoader && (
                <LoaderPopUp showLoader={showBtnLoader} />
            )) || (
                    <div className={classes.root}>
                        {
                            userTeam != 'ITeC Team' ? (
                                ''
                            ) : (
                                    <CardContent>
                                        <Grid container className="main-container">
                                            <Grid item xs={6} sm={6} className={classes.marginBtm}>
                                                <FormControl fullWidth className={classes.margin}>
                                                    <InputLabel className="lbl" htmlFor="intclientName" shrink>
                                                        Select IMC
                                            </InputLabel>
                                                    <Select
                                                        native
                                                        className="bottom"
                                                        name="intclientName"
                                                        onChange={setImcCorporate}
                                                        value={selectedImc}
                                                    >
                                                        <option value="" selected disabled hidden>
                                                            Select IMC
                                                </option>
                                                        {allImcsOptions(AllImcs)}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6} sm={6} className={classes.marginBtm}>
                                                <FormControl fullWidth className={classes.margin}>
                                                    <InputLabel className="lbl" htmlFor="corpClientId" shrink>
                                                        Select Corp
                                            </InputLabel>
                                                    <Select native className="bottom" name="corpClientId" onChange={setCorp} value={selectedCorp}>
                                                        <option value="" selected disabled hidden>
                                                            Select Corp
                                                </option>
                                                        {allCorpOptions(allCorps)}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                )
                        }
                        <Card className="custom-table">
                            <CardContent className="card-title-display">
                                <Grid item xs={12} sm={8}>
                                    <Typography className="card-title">Payment History</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} className="card-search">
                                    <div className="search-field">
                                        <SearchBox
                                            searchQuery={searchQuery}
                                            onChange={handleSearchQuery}
                                            clearField={clearField}
                                            placeholder="Search..."
                                        />
                                    </div>
                                </Grid>
                            </CardContent>
                            <CardContent className="card-table-display">
                                {rows && filteredRow.length > 0 ? (
                                    userTeam === 'Team' ? (
                                        <PaymentTable
                                            headcells={headcells}
                                            rows={filteredRow}
                                            // pageName={userTeam}
                                            handleGenerateReceipt={handleGenerateReceipt}
                                            action
                                            attachment
                                            remarks
                                            handleCount={handleCount}
                                            pageDetails={pageDetails}
                                            loading={loading}
                                            prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                        />
                                    ) : (
                                            <PaymentTable
                                                headcells={headcells}
                                                rows={filteredRow}
                                                // pageName={userTeam}
                                                handleGenerateReceipt={handleGenerateReceipt}
                                                //  action
                                                attachment
                                                remarks
                                                handleCount={handleCount}
                                                pageDetails={pageDetails}
                                                loading={loading}
                                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                            />
                                        )
                                ) : (
                                        <div className={classes.noRecord}>
                                            <h1>No records to display</h1>
                                        </div>
                                    )}
                            </CardContent>
                        </Card>
                    </div>
                )}
        </>
    );
}

export default IndividualPaymentHistory;
